module.exports = __webpack_public_path__ + "static/img/2.8605161.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/eng/2.png
// module id = +mLW
// module chunks = 0